import "@/helpers/turbo"
import "@/styles/home.scss"

import { application } from "../helpers/stimulus"

import { setupGeolocation } from "@/components/geolocation"
import { setupSearchBar } from "@/components/search_bar"

import CarouselController from "../controllers/carousel_controller"
import TabsController from "../controllers/tabs_controller"

const setupStimulus = (): void => {
  application.register("carousel", CarouselController)
  application.register("tabs", TabsController)
}

setupSearchBar()
setupStimulus()

const BROWSER_GEOLOCATION = document.body.getAttribute("data-browser-gelocation") === "true"

if (BROWSER_GEOLOCATION) {
  void setupGeolocation()
}
